import React from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { SuperSEO } from "react-super-seo";

import { Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { Link } from "react-router-dom";
import { upperCase } from "../../utils";

const ProgrammesLayout = (props) => {
  const context = useContext(PsContext);

  return (
    <>
      <section>
        <div className="head-2">
          <div className="container">
            <div className="head-2-inn head-2-inn-padd-top">
              <h1>{upperCase(props.courseType)} Programmes</h1>
              {/*<p>Fusce id sem at ligula laoreet hendrerit venenatis sed purus. Ut pellentesque maximus lacus, nec pharetra augue.</p>
                    <div className="event-head-sub">
                        <ul>
                            <li>Topic: Global warming</li>
                            <li>Time: 09:15 am – 5:00 pm</li>
                            <li>Location: Illunois</li>
                        </ul>
					</div>*/}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container com-sp pad-bot-70 pg-inn ps_min_height">
          <SuperSEO
            title={context.settingValue("print_header_name")}
            description={context.settingValue("print_header_name")}
            lang="en"
          />

          <Row>
            <Col md={9}>
              {/*<div className="cor-p1 mt-0">
						<h2 className='text-center'></h2>
						<span>Category: Software Testing</span>
						<div className="share-btn">
							<ul>
								<li><a href="#"><i className="fa fa-facebook fb1"></i> Share On Facebook</a>
								</li>
								<li><a href="#"><i className="fa fa-twitter tw1"></i> Share On Twitter</a>
								</li>
								<li><a href="#"><i className="fa fa-google-plus gp1"></i> Share On Google Plus</a>
								</li>
							</ul>
						</div>
					</div>*/}
              {props.children}
            </Col>
            <Col md={3}>
              <div className="de-left-tit py-2">
                <h4 className="fs-16">
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Programmes
                </h4>
              </div>
              <div className="ho-event">
                <ul className="ps__sidebar__links ps-0">
                  <li>
                    <i className="fa-solid fa-chevron-right me-2"></i>
                    <Link to="/programmes/ug">UG Programmes</Link>
                  </li>
                  <li>
                    <i className="fa-solid fa-chevron-right me-2"></i>
                    <Link to="/programmes/pg">PG Programmes</Link>
                  </li>
                  {/*<li>
                    <i className="fa-solid fa-chevron-right me-2"></i>
                    <Link to="/programmes/mphil">MPhil Programmes</Link>
                  </li>
                  <li>
                    <i className="fa-solid fa-chevron-right me-2"></i>
                    <Link to="/programmes/phd">PhD Programmes</Link>
        </li>*/}
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default ProgrammesLayout;
